import React from 'react';
import { Link } from 'react-router-dom';
import NavigationLinks from '../components/NavigationLinks';

export default function Patients() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 font-sans">
      <NavigationLinks />
      
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-slate-900">👥 Patient Intake</h1>
        <p className="text-slate-500 mt-2">Manage patient cases and triage</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map(i => (
          <div key={i} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold">
                {i}
              </div>
              <div>
                <h3 className="font-semibold text-slate-800">Patient {i}</h3>
                <p className="text-xs text-slate-400">ID: P-00{i}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 mb-3">
              <span className="px-2 py-0.5 bg-slate-100 rounded-full text-[10px] text-slate-600">COPD</span>
              <span className="px-2 py-0.5 bg-slate-100 rounded-full text-[10px] text-slate-600">In Progress</span>
            </div>
            <Link 
              to="/insights" 
              className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
            >
              View Analysis →
            </Link>
          </div>
        ))}
      </div>
      
      <Link to="/insights" className="inline-block mt-8 text-indigo-600 hover:text-indigo-800">
        ← Back to Insights
      </Link>
    </div>
  );
}
